var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStockDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 35V24.999M25 24.999L15.3223 19.9985M25 24.999L34.6778 19.9985M20 17.2678L30 22.4183M23.8889 34.7299C24.2267 34.9054 24.6099 34.9979 25 34.9979C25.3901 34.9979 25.7733 34.9054 26.1111 34.7299L33.8889 30.7295C34.2264 30.5541 34.5067 30.3019 34.7017 29.9982C34.8967 29.6946 34.9996 29.3501 35 28.9993V20.9985C34.9996 20.6478 34.8967 20.3033 34.7017 19.9996C34.5067 19.6959 34.2264 19.4437 33.8889 19.2684L26.1111 15.268C25.7733 15.0924 25.3901 15 25 15C24.6099 15 24.2267 15.0924 23.8889 15.268L16.1111 19.2684C15.7736 19.4437 15.4933 19.6959 15.2983 19.9996C15.1033 20.3033 15.0004 20.6478 15 20.9985V28.9993C15.0004 29.3501 15.1033 29.6946 15.2983 29.9982C15.4933 30.3019 15.7736 30.5541 16.1111 30.7295L23.8889 34.7299Z",
    stroke: "#475569",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStockDetails);
export default __webpack_public_path__ + "static/media/stock-details.9a36ce0d4e5230a21222b6606aae05f8.svg";
export { ForwardRef as ReactComponent };